import _ from "lodash";
import api from "../../api/portfolio";

export default {
	namespaced: true,
	state: {
		_portfolio: {
			type: "",
			thumb: "",
			banners: [],
			banners_mobile: [],
			title: "",
			sub_title: "",
			youtube: "",
			details: "",
		},
		_portfolioList: new Array
	},
	actions: {
		_getList({ state }) {
			return new Promise((resolve, reject) => {
				api.__getList()
					.then(res => {
						state._portfolioList = res;
						resolve(res)
					})
					.catch(err => reject(err))
			})
		},
		_getData({ state }, id) {
			return new Promise((resolve, reject) => {
				api.__getData(id)
					.then(res => {
						state._portfolio = res;
						resolve(res)
					})
					.catch(err => reject(err))
			})
		},
		_createData({ state }, data) {
			return new Promise((resolve, reject) => {
				api.__createData(data)
					.then(res => {
						_.assign(state._portfolio, _.cloneDeep(data));
						resolve(res)
					})
					.catch(err => reject(err))
			})
		},
		_updateData({ state }, { id, data }) {
			return new Promise((resolve, reject) => {
				api.__updateData({ id, data })
					.then(res => {
						_.assign(state._portfolio, _.cloneDeep(data));
						resolve(res)
					})
					.catch(err => reject(err))
			})
		},
		_removeData({ }, id) {
			return new Promise((resolve, reject) => {
				api.__removeData(id)
					.then(res => resolve(res))
					.catch(err => reject(err))
			})
		},
	}
}